'use client';

import React from 'react';
import type { LearnHubPage } from '@benzinga/content-manager';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import { LearnModuleCards, LearnPresentedBy } from '../Learn';
import styles from '../Learn/Learn.module.css';

export interface LearnHubTemplateProps {
  learn?: LearnHubPage | null;
}

export const LearnHubTemplate: React.FC<LearnHubTemplateProps> = ({ learn }) => {
  return (
    <div className={`${styles.page} learn-hub-template relative min-h-screen text-bzblue-300`}>
      <div className={`${styles.coverBand} pointer-events-none absolute`} />
      <div className="relative mx-auto max-w-[1400px] px-4 pb-12 pt-6 lg:px-8 lg:pb-16 lg:pt-8">
        <header className="pb-12 pt-10 lg:pb-20 lg:pt-20">
          <h1 className="m-0 text-[2.5rem] font-bold leading-[1.05] text-white lg:text-[4rem]">{learn?.title}</h1>
          <LearnPresentedBy className="mt-3" logo={learn?.presented_by ?? undefined} />
          {learn?.intro && (
            <div
              className={`${styles.hubIntro} mt-4 max-w-2xl text-[0.9375rem] leading-relaxed text-bzblue-400 lg:text-base [&_a]:text-bzblue-600 [&_p:last-child]:mb-0`}
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(learn.intro) }}
            />
          )}
        </header>
        <LearnModuleCards modules={learn?.modules} />
      </div>
    </div>
  );
};

export default LearnHubTemplate;
